import React from 'react'
import { CaretRightFill, CaretDownFill } from 'react-bootstrap-icons'

const AccordionIcon = ({
    active
}) => {
    const Icon = active ? CaretDownFill : CaretRightFill
    return (
        <Icon style={{ paddingRight: '5px'}} />
    )
}

export default AccordionIcon
